module.exports = __webpack_public_path__ + "static/icons/icon-check-pago-efectivo.2988ba2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-tarjeta-credito/icon-check-pago-efectivo.svg
// module id = tRZa
// module chunks = 1